import { render, staticRenderFns } from "./GeneralDetail.vue?vue&type=template&id=0343796a&"
import script from "./GeneralDetail.vue?vue&type=script&lang=js&"
export * from "./GeneralDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports